import React, { useMemo } from 'react';
import { BsAward, BsCalendar } from 'react-icons/bs';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import { getDateString } from '../../../utils/dateUtil';

const PolicyCard = ({ policy }) => {
  const dateString = useMemo(() => {
    const start = getDateString(policy.effectiveAt, 'MM/DD/YYYY');
    const end = getDateString(policy.expiresAt, 'MM/DD/YYYY');

    return `${start} - ${end}`;
  }, [policy]);

  return (
    <Box
      _hover={{ boxShadow: 'hover2' }}
      borderRadius="10px"
      boxShadow="sharp4"
      flexBasis="100%"
      layerStyle="panel"
      mb={4}
      minH="100px"
      minW="480px"
      mr={4}
      mt={1}
      textAlign="left"
      w="100%"
    >
      <Box p={6}>
        <Text
          color={colors.greyScale['900']}
          mb={2}
          textStyle="bodyMd600"
        >
          {policy.insurancePolicyType.displayName}
        </Text>
        <HStack justifyContent="space-between">
          <HStack>
            <Icon
              as={BsAward}
              boxSize="18px"
              color={colors.primaryScale['400']}
            />
            <Text textStyle="bodySm500">{policy.number}</Text>
          </HStack>

          <HStack>
            <Icon
              as={BsCalendar}
              boxSize="18px"
              color={colors.primaryScale['400']}
            />
            <Text textStyle="bodySm500">{dateString}</Text>
          </HStack>
        </HStack>
      </Box>
    </Box>
  );
};

PolicyCard.propTypes = {
  policy: PropTypes.shape({
    effectiveAt: PropTypes.string,
    expiresAt: PropTypes.string,
    number: PropTypes.string,
    insurancePolicyType: PropTypes.shape({ displayName: PropTypes.string })
  })
};

export default PolicyCard;
